import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { IntlShape, injectIntl } from 'react-intl';
import { translate } from 'helpers/intl';

import Header from 'containers/SignupPages/Header';
import messages from 'containers/SignupPages/AuthBySms/messages';
import Form from 'containers/SignupPages/AuthBySms/Form';
import { getPhoneSelector } from 'store/user/selectors';
import {
  PERSONAL_INFO,
  AUTH_BY_CONTRACT,
} from 'containers/SignupPages/constants';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import { EVENT_CATEGORIES } from 'helpers/GATracking';

export type AuthBySmsType = {
  intl: IntlShape;
  phone: string;
  onSubmitStep: Function;
  isLoading: boolean;
  setSignupStep: Function;
};

const AuthBySms = (props: AuthBySmsType) => {
  return (
    <GaLoadHOC category={EVENT_CATEGORIES.AUTH_BY_SMS}>
      <>
        <Header
          title={translate({ ...messages.title }, props)}
          subTitle={`${translate({ ...messages.subTitle }, props)} ${
            props.phone
          } :`}
        />
        <Form
          isLoading={props.isLoading}
          onClickPrevious={() => {
            props.setSignupStep(PERSONAL_INFO);
          }}
          proceedDifferently={() => {
            props.setSignupStep(AUTH_BY_CONTRACT);
          }}
          onSubmitStep={props.onSubmitStep}
        />
      </>
    </GaLoadHOC>
  );
};

const mapStateToProps = createStructuredSelector<any, { phone: string }>({
  phone: getPhoneSelector,
});

export default connect(mapStateToProps)(injectIntl(AuthBySms));
